import { ButtonProps } from "@mui/material";
import classNames from "classnames";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { TrashIcon } from "../../../../shared/icons/TrashIcon";
import styles from "./styles.module.css";

interface Props extends ButtonProps {
  entityId: string;
  onDelete: (id: string) => void;
  isDisabled?: boolean;
  className?: string;
}

export const DeleteButton = ({
  entityId,
  onDelete,
  isDisabled,
  className,
  ...rest
}: Props) => {
  const cls = classNames(styles.button, styles["delete-button"], className);

  return (
    <AppIconButton
      disabled={isDisabled}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDelete(entityId);
      }}
      className={cls}
      {...rest}
    >
      <TrashIcon />
    </AppIconButton>
  );
};
